import React, {useCallback, useState} from 'react';

import Button from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';

type Props = {
    title: string,
    busy?: boolean,
    message: string,
    onConfirm: () => void,
    children: React.ReactNode,
};
export const ConfirmationModal = (props: Props) => {
    const {title, message, onConfirm, children, busy} = props;

    const [shown, setShown] = useState<boolean>(false);

    const onConfirmHandler = () => {
        setShown(false);
        onConfirm();
    };

    const openModal = useCallback(() => {
        if (!busy) {
            setShown(true);
        }
    }, [busy]);

    const closeModal = useCallback(() => {
        setShown(false);
    }, []);

    return (
        <>
            <div onClick={openModal}>
                {children}
            </div>
            <Dialog
                shown={shown}
                setShown={closeModal}
                wrapperProps={{style: {width: 600}}}>
                <DialogHeader onClose={closeModal}>
                    {title}
                </DialogHeader>
                <DialogMain style={{padding: 24}}>
                    {message}
                </DialogMain>
                <DialogFooter>
                    <Group>
                        <Button variant="Type.PRIMARY" onClick={onConfirmHandler}>
                            Confirm
                        </Button>
                        <Button variant="Type.SECONDARY" onClick={closeModal}>
                            Cancel
                        </Button>
                    </Group>
                </DialogFooter>
            </Dialog>
        </>
    );
};
